module.exports = __webpack_public_path__ + "media/images/favicon/apple-touch-icon-152x152-76721c80b80af09a2f7df8ce69d955ed.png";